import { useContext, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import DetailsCard from 'components/molecules/DetailsCard/DetailsCard';
import { Calculation, CalculationType } from 'types/domainTypes';
import { CalculationContext } from 'pages/Calculation/CalculationContextProvider';

type CalculationInputCardsComponentProps = {
  calculation: Calculation;
  onClickProduct: () => void;
  onClickSpansAndLoads: () => void;
  onClickTemperature: () => void;
  onClickFasteners: () => void;
  onClickZones: () => void;
};

const CalculationInputCardsComponent = ({
  calculation,
  onClickProduct,
  onClickSpansAndLoads,
  onClickTemperature,
  onClickFasteners,
  onClickZones,
}: CalculationInputCardsComponentProps): ReactElement => {
  const { t } = useTranslation();
  const { shouldShowFastenersTooltip } = useContext(CalculationContext);

  return (
    <Grid container spacing={3} wrap="wrap" marginBottom="24px">
      {!calculation.product && (
        <DetailsCard
          cardTestId="product-details-card"
          buttonTestId="add-product-details-button"
          labelText={t('calculation-page.label-add-product-details')}
          onClick={onClickProduct}
        />
      )}
      {calculation.details.type !== CalculationType.FastenerCheck && !calculation.spansAndLoads && (
        <DetailsCard
          cardTestId="load-details-card"
          buttonTestId="add-spans-loads-details-button"
          labelText={t('calculation-page.label-add-spans-loads-details')}
          onClick={onClickSpansAndLoads}
        />
      )}
      {!calculation.temperature && (
        <DetailsCard
          cardTestId="temperature-details-card"
          buttonTestId="add-temperature-details-button"
          labelText={t('calculation-page.label-add-temperature-details')}
          onClick={onClickTemperature}
        />
      )}
      {!calculation.fasteners && (
        <DetailsCard
          cardTestId="fastener-details-card"
          buttonTestId="add-fasteners-details-button"
          labelText={t('calculation-page.label-add-fasteners-details')}
          onClick={onClickFasteners}
          showTooltip={shouldShowFastenersTooltip}
        />
      )}
      {calculation.details.type === CalculationType.FastenerCheck && !calculation.zoneDetails && onClickZones && (
        <DetailsCard
          cardTestId="zones-card"
          buttonTestId="add-zones-button"
          labelText={t('calculation-page.label-add-zones')}
          onClick={onClickZones}
        />
      )}
    </Grid>
  );
};

export default CalculationInputCardsComponent;
